module.exports = __webpack_public_path__ + "img/clubcard-gold-bg.939338c1.svg";